import cnBind from "classnames/bind";
import Link from "next/link";
import type { UrlObject } from "node:url";
import { LinkIcon } from "@/shared/assests/svg/svg";
import { CustomImage } from "@/shared/ui/CustomImage";
import styles from "./HistoryCard.module.scss";

const cx = cnBind.bind(styles);

type HistoryCardProps = {
    image: string;
    title: string;
    description?: string;
    listHref?: {
        title: string;
        href: UrlObject | string;
        as?: string;
        typeOnClick?: () => void;
    }[];
    onClick?: () => void;
    className?: string;
    type?: boolean;
    link?: boolean;
    globalHref?: string; // Добавили проп для ссылки на всю карточку (для О Компании)
};

export const HistoryCard = ({
                                listHref,
                                description,
                                image,
                                title,
                                onClick,
                                className,
                                type = true,
                                link,
                                globalHref,
                            }: HistoryCardProps) => {

    // Внутреннее содержимое карточки
    const renderInnerContent = () => (
        <>
            <CustomImage
                src={image}
                alt={title}
                fill
                sizes="(max-width: 576px) 250px, (max-width: 1024px) 50vw, 400px"
                style={{ objectFit: "cover" }}
                className={cx("background-image")}
            />
            <div className={cx("content")}>
                <h3 className={cx("title")}>{title}</h3>

                {description && (
                    <p onClick={onClick} className={cx("description")}>
                        {description}
                    </p>
                )}

                {listHref && (
                    <ul className={cx("list")}>
                        {listHref.map((item, i) => (
                            <li key={i} className={cx("list-item")}>
                                {type ? (
                                    <Link href={item.href} as={item.as} className={cx("list-link")} onClick={item.typeOnClick}>
                                        {item.title}
                                    </Link>
                                ) : (
                                    <Link target={link ? "_blank" : "_self"} className={cx("list-link")} href={item.href} as={item.as}>
                                        {item.title}
                                    </Link>
                                )}
                                <LinkIcon className={cx("list-icon")} />
                            </li>
                        ))}
                    </ul>
                )}
            </div>
        </>
    );

    if (globalHref) {
        return (
            <Link href={globalHref} className={cx("history-card", "is-link-card", className)}>
                {renderInnerContent()}
            </Link>
        );
    }

    return (
        <div
            onClick={onClick}
            className={cx("history-card", onClick && "is-link-card", className)}
        >
            {renderInnerContent()}
        </div>
    );
};
